import { DATE_FORMAT, PARAMETER_DATE_FORMAT_WITHOUT_TZ } from "@gymflow/common";
import { formatCurrency } from "@gymflow/helpers";
import { useClubSettings } from "apps/portal/src/providers";
import { REVENUE_CATEGORY_MAP } from "apps/portal/src/views/reports/RevenueTotal/constants";
import moment from "moment";
import QueryString from "qs";
import { useContext } from "react";
import { useHistory } from "react-router";

import ReportWidgetCard from "../../../../ReportWidgetCard/ReportWidgetCard";
import { ReportContext } from "../../../ReportContext";
import { usePortalRoutes } from "./../../../../../hooks/usePortalRoutes";
import { RouteFeature } from "./../../../../../routes/feature";
import { RouteLayout } from "./../../../../../routes/layout";

export const ReportRevenueSalesSummarySessionWidget = ({
  parentRoute,
}: {
  parentRoute: string;
}) => {
  const { createClubLink } = usePortalRoutes();
  const data = useContext(ReportContext);
  const history = useHistory();

  const { club } = useClubSettings();

  return (
    <ReportWidgetCard
      title="Credit Packs Revenue"
      value={formatCurrency(
        Math.round(data.revenue?.sessionPack?.total || 0),
        club.defaultCurrency,
        true,
      )}
      isLoading={data.isLoading}
      variation={data.revenue?.sessionPack?.variation}
      explanation="Sum of all stand-alone credit pack sales, less any refunds or credits applied. Does not include payments awaiting authorization."
      onClick={() =>
        history.push({
          pathname: createClubLink(RouteLayout.Staff, RouteFeature.Revenue),
          search: QueryString.stringify({
            dates: {
              startDate: moment(data.startDate, DATE_FORMAT).format(
                PARAMETER_DATE_FORMAT_WITHOUT_TZ,
              ),
              endDate: moment(data.endDate, DATE_FORMAT)
                .endOf("day")
                .format(PARAMETER_DATE_FORMAT_WITHOUT_TZ),
            },
            invoiceType: REVENUE_CATEGORY_MAP.CreditPack,
            backRoute: parentRoute,
          }),
        })
      }
    />
  );
};
